/* NBT: vertaalt een tekst via window.NB_T. Zonder tabel (Japans) komt het origineel terug.
   Staat de hele tekst er niet in, dan worden bekende woorden binnenin vervangen (HTML-fragmenten). */
function NBT(s) {
  var T = window.NB_T;
  if (!T || typeof s !== 'string') return s;
  if (Object.prototype.hasOwnProperty.call(T, s)) return T[s];
  var k = window.NB_TK || (window.NB_TK = Object.keys(T).sort(function (a, b) { return b.length - a.length; }));
  var uit = s;
  for (var i = 0; i < k.length; i++) {
    if (uit.indexOf(k[i]) !== -1) uit = uit.split(k[i]).join(T[k[i]]);
  }
  return uit;
}
/* Winkelwagen-lade: openen/sluiten, aantal wijzigen, verwijderen, upsell toevoegen. Inhoud wordt opnieuw opgehaald via de Section Rendering API. */
(function () {
  var SECTIE = 'nb-cart-drawer';
  var lade = document.querySelector('[data-nb-cartlade]');
  if (!lade) return;
  if (lade.parentNode !== document.body) document.body.appendChild(lade);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function open() {
    lade.classList.add('is-open');
    lade.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function sluit() {
    lade.classList.remove('is-open');
    lade.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function zetInhoud(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nieuw = tmp.querySelector('[data-nb-cart-inhoud]');
    var oud = lade.querySelector('[data-nb-cart-inhoud]');
    if (nieuw && oud) {
      var midden = oud.querySelector('.nb-cart__midden');
      var scroll = midden ? midden.scrollTop : 0;
      oud.innerHTML = nieuw.innerHTML;
      midden = oud.querySelector('.nb-cart__midden');
      if (midden) midden.scrollTop = scroll;
    }
  }
  function ververs() {
    return fetch(root + '?sections=' + SECTIE, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { if (s[SECTIE]) zetInhoud(s[SECTIE]); document.dispatchEvent(new CustomEvent('cart:update')); });
  }
  function stuur(pad, body) {
    lade.classList.add('is-bezig');
    body.sections = SECTIE;
    return fetch(root + pad, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections && res.sections[SECTIE]) { zetInhoud(res.sections[SECTIE]); document.dispatchEvent(new CustomEvent('cart:update')); return; }
        return ververs();
      })
      .catch(function () { return ververs(); })
      .then(function () { lade.classList.remove('is-bezig'); });
  }

  lade.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-nb-cart-sluit]')) { sluit(); return; }
    var item = t.closest('.nb-cart__item');
    if (item) {
      var qtyEl = item.querySelector('[data-nb-cart-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      if (t.closest('[data-nb-cart-weg]')) { stuur('cart/change.js', { id: item.dataset.key, quantity: 0 }); return; }
      if (t.closest('[data-nb-cart-min]')) { stuur('cart/change.js', { id: item.dataset.key, quantity: qty - 1 }); return; }
      if (t.closest('[data-nb-cart-plus]')) { stuur('cart/change.js', { id: item.dataset.key, quantity: qty + 1 }); return; }
    }
    var up = t.closest('[data-nb-cart-upsell]');
    if (up) {
      var keuze = up.closest('.nb-cart__upsell').querySelector('[data-nb-cart-upsell-keuze]');
      var id = parseInt(keuze ? keuze.value : up.dataset.nbCartUpsell, 10);
      stuur('cart/add.js', { items: [{ id: id, quantity: 1 }] });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lade.classList.contains('is-open')) sluit(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) ververs(); });

  window.NBCart = { open: open, sluit: sluit, ververs: ververs, zetInhoud: zetInhoud, sectie: SECTIE };
})();
